import React, { useEffect, useState, } from 'react';
import { Button, Alert } from '@emorg-prd/react-standard';
import './index.css';
import DisplayLocation from '../../../shared/displayLocation';
import EditLocation from '../editLocation';
import LoaderIcon from '../../../loaderIcon';
import { Destination } from '../../../../api/Destination.js';
import { useParams } from "react-router-dom";


const ViewExistingLocation = (props) => {
  let { isAuthorized } = props;
  let { id } = useParams(); //location id from route path /viewLocation/:id
  const [locationId, setLocationId] = useState(null);
  const [isViewMode, setIsViewMode] = useState(true);
  const [pageLoaded, setPageLoaded] = useState(true);
  const [errorCode, setErrorCode] = useState('');
  const [locationState, setLocationState] = useState({
    locationName: '',
    locationStreetAddress1: '',
    locationStreetAddress2: '',
    country: { id: null, name: '' },
    countrySubdivision: { id: null, name: '' },
    locationCity: '',
    locationPostalCode: '',
    locationCounty: '',
    latitude: '',
    longitude: '',
    timezone: { timezoneId: null, timezoneName: '' },
    locationDesc: '',
    realEstateInterestList: [
      {
        realEstateInterestId: 0,
        realEstateInterestName: '',
        realEstateInterestTypeId: '0',
        primary: true,
        realEstateInterestSourceSystemRelate: [
          {
            realEstateInterestSourceSystemName: '',
            realEstateInterestSourceSystemIdTypeName: '',
            realEstateInterestSourceSystemReferenceID: '',
          },
        ],
        realEstateInterestDesc: '',
        realEstateInterestLatitude: '',
        realEstateInterestLongitude: '',
        realEstateInterestfrontageSize: '',
        realEstateInterestDepthSize: '',
        realEstateInterestArea: '',
        realEstateInterestSizeUOM: '',
        realEstateInterestBusinessLineAlias: '',
        locationId: '',
      },
    ],
    realEstateInterestDropdown: [[]],
    primaryUseType: { id: null, name: '', parentId: null },
    isJointVenture: false,
    affiliateOwnershipPercentage: '0',
    jVOwnershipPercentage: '0',
    destinationSystem: {
      Connexion: Destination.Connexion,
    },
    locationOperationStatus: { id: null, name: '' },
    storeBrand: { id: null, name: '' },
    fuelBrand: { id: null, name: '' },
    stewardshipCostObjectList: [
      {
        stewardshipTypeId: '',
        stewardshipTypeName: '',
        costObjectTypeId: '',
        costObjectTypeName: '',
        costObject: '',
      },
    ],
    sourceSystemLinkList: [
      {
        sourceSystemId: '',
        sourceSystemName: '',
        sourceSystemIdTypeId: '',
        sourceSystemIdTypeName: '',
        sourceSystemReferenceId: '',
      },
    ],
    businessLineAllocationList: [
      {
        businessLineCode: 0,
        businessLineName: '',
        businessLineReportUnitCompanyCode: 0,
        businessLineReportUnitName: '',
        allocationPercent: 0,
        locationId: '',
      },
    ],
    epsBusinessLineAllocationList: [
      {
        eps_business_vc_id: 0,
        businessValueChain: '',
        eps_business_line_id: 0,
        businessLine: '',
        epsAllocationPercent: 0,
      },
    ],
    siteId: 0,
    siteName: '',
    siteCode: '',
    siteOperationStatus: '',
    siteOperationStatusId: 0,
    sitePrimaryUseType: '',
    sitePrimaryUseTypeId: 0,
    itSiteCodeList: [
      {
        itSiteCodeId: '',
        itSiteCode: '',
        itSiteCodeDesc: '',
      },
    ],
    siteSourceLinkList: [
      {
        sourceSystemId: '',
        sourceSystemName: '',
        sourceSystemIdTypeName: '',
        sourceSystemIdTypeId: '',
        sourceSystemReferenceId: '',
      },
    ],
    buildingList: [
      {
        buildingId: 0,
        buildingName: '',
        buildingDesc: '',
        sourceSystemId: 0,
        sourceSystemReferenceId: '',
        sourceSystemIdTypeId: 0,
        isNuvoloBuildingValid: false,
        previousNuvoloBuildingId: '',
        validationSymbol: '',
        loadingValidation: false,
        validationErrorMessage: '',
      }
    ],
    toggleNewExisting: undefined,
    isCheckedConnexion: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [sourceSystemList, setSourceSystemList] = useState();
  const [sourceSystemTypeList, setSourceSystemTypeList] = useState();

  useEffect(() => {
    setIsViewMode(true);
    setLocationId(id);
  }, []);

  const handleViewMode = (bool) => {
    setIsViewMode(bool);
    locationState.sourceSystemLinkList.forEach((source) => {
      if (
        source.sourceSystemIdTypeName.toLowerCase() === 'sap_location_code' &&
        source.sourceSystemReferenceId
      ) {
        onChange('isCheckedConnexion', true);
      }
    });
  };

  const onChange = (field, value) => {
    setLocationState((prev) => ({ ...prev, [field]: value }));
  };

  const showLoadingSpinner = (value) => {
    setIsLoading(value);
  };

  const handlePageError = (message) => {
    switch (true) {
      case (message.includes('Network')):
        setErrorCode('Network');
        break;
      case (message.includes('400')):
        setErrorCode('Bad Request');
        break;
      case (message.includes('403')):
        setErrorCode('Forbidden');
        break;
      case (message.includes('404')):
        setErrorCode('Not Found');
        break;
      case (message.includes('500') || message.includes('Internal Server')):
        setErrorCode('Internal Server');
        break;
      case (message.includes('map')):
        setErrorCode('Mapping');
        break;
      default:
        break;
    }
    setPageLoaded(false);
  }

  return (
    <div className='page'>
      {pageLoaded && <div>
        {isLoading && <LoaderIcon />}
        {!isLoading && !isAuthorized &&
          <Alert variant='error' className='view-auth-alert'>
            User is Not Authorized to Edit Locations
          </Alert>
        }
        <h3 className='viewPage'>{locationState.locationName}</h3>
        {isViewMode ? (
          <>
            <DisplayLocation
              {...locationState}
              onChange={onChange}
              handlePageError={handlePageError}
              locationId={locationId}
              setLocationId={setLocationId}
              showLoadingSpinner={showLoadingSpinner}
            ></DisplayLocation>
            <a href='/searchLocation'>
              <Button
                className='small-margin viewPage'
                variant='secondary'
                style={{ marginRight: '10px' }}
                onClick={props.navigateBackward}
              >
                Back
            </Button>
            </a>

            {locationId ? (
              <>
                <Button
                  className='small-margin'
                  variant='primary'
                  onClick={() => handleViewMode(false)}
                  disabled={!isAuthorized}
                >
                  Edit
              </Button>
              </>
            ) : (
                null
              )}
          </>
        ) : (
            <EditLocation
              locationState={locationState}
              onChange={onChange}
              isAuthorized={isAuthorized}
              handlePageError={handlePageError}
              locationId={locationId}
              showLoadingSpinner={showLoadingSpinner}
              setSourceSystemTypeList={setSourceSystemTypeList}
              setSourceSystemList={setSourceSystemList}
              sourceSystemTypeList={sourceSystemTypeList}
              sourceSystemList={sourceSystemList}
              locationStateLocationId={locationState.businessLineAllocationList[0].locationId}
            ></EditLocation>
          )}
      </div>}

      {!pageLoaded && <div>
        <h1 style={{ textAlign: 'center', fontSize: '2rem' }}>
          {errorCode} Error Occurred
        </h1>
      </div>}
    </div>
  );
};
export default ViewExistingLocation;
